import React from "react";
import { Link } from "react-router-dom";

/**
 * A cross-reference hashtag. Clicking it opens /projects/tag/<tag>, which lists
 * every note that shares the tag, across all blocks.
 *
 * variant="inline"  → reads like #tag inside prose (default)
 * variant="chip"    → a bordered pill, for tag rows on cards
 */
export default function HashTag({ tag, variant = "inline", className = "" }) {
  const base =
    variant === "chip"
      ? "inline-flex items-center px-3 py-1 rounded-full text-sm border border-border bg-surface-elevated text-muted-foreground hover:text-accent hover:border-accent/40 transition-colors"
      : "text-accent hover:text-accent-hover transition-colors";

  return (
    <Link to={`/projects/tag/${encodeURIComponent(tag)}`} className={`${base} ${className}`}>
      #{tag}
    </Link>
  );
}
